import ActiveStepIcon from './ActiveStepIcon.svg';
import DefaultStepIcon from './DefaultStepIcon.svg';
import SuccessStepIcon from './SuccessStepIcon.svg';
import CompletedStepIcon from './CompletedStepIcon.svg';
import StepHelp from './StepHelp.svg';
import StepLine from './StepLine';

export default {
  ActiveStepIcon,
  DefaultStepIcon,
  SuccessStepIcon,
  CompletedStepIcon,
  StepHelp,
  StepLine,
};
